import React from 'react';
import type { IDocument } from 'src/interfaces/document';
import { formatDocumentDescription } from 'src/modules/conversations/helpers/formatDocumentsDescription';
import type { TDocumentation } from 'src/modules/conversations/components/types';
import {
    getDocumentationContentType,
    getDocumentationMediaUrl,
} from 'src/views/OmniChannel/utils/documentation';
import { DocumentsGridItem } from '../documents';

type TDocumentationDocumentItemProps = {
    document: IDocument;
    documentation: TDocumentation[];
    onToggle: (document: IDocument) => void;
    onPreview: (document: IDocument) => void;
    t: (key: string) => string;
};

export const DocumentationDocumentItem = ({
    document,
    documentation,
    onToggle,
    onPreview,
    t,
}: TDocumentationDocumentItemProps) => {
    const isSelected = documentation.some((item) => item._id === document._id);
    const hasFile = Boolean(document.file?.trim());
    const title = formatDocumentDescription(document, t);
    const subtitle = document.store?.name;

    return (
        <DocumentsGridItem
            mediaUrl={hasFile ? getDocumentationMediaUrl(document.file) : undefined}
            mediaContentType={getDocumentationContentType(document.file)}
            mediaAlt={title}
            title={title}
            subtitle={subtitle}
            selected={isSelected}
            showSelection
            onClick={() => onToggle(document)}
            onMediaPreview={hasFile ? () => onPreview(document) : undefined}
        />
    );
};
